import { useEffect, useState } from "react";

const TEXT_PREVIEW_CHAR_LIMIT = 200;

export const useTextContent = (url: string | undefined, enabled: boolean) => {
  const [content, setContent] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !url) return;

    const controller = new AbortController();

    fetch(url, {
      signal: controller.signal,
      headers: { Range: `bytes=0-${TEXT_PREVIEW_CHAR_LIMIT * 4 - 1}` },
    })
      .then(res => res.text())
      .then(text => {
        if (!controller.signal.aborted) {
          setContent(text.slice(0, TEXT_PREVIEW_CHAR_LIMIT));
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) setContent(null);
      });

    return () => controller.abort();
  }, [url, enabled]);

  return content;
};
